'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MIN_WIDTHS = exports.generate = exports.Placeholder = undefined;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _cloudinary = require('web-fns/dist/cloudinary');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    } else {
        cooked.raw = raw;
    }
    return cooked;
};
var Placeholder = exports.Placeholder = _styledComponents2.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  background: linear-gradient(\n    90deg,\n    rgba(207, 216, 220, 0.2),\n    rgba(207, 216, 220, 0.4),\n    rgba(207, 216, 220, 0.2)\n  );\n  border-radius: ", ";\n"], ["\n  width: ", "px;\n  height: ", "px;\n  background: linear-gradient(\n    90deg,\n    rgba(207, 216, 220, 0.2),\n    rgba(207, 216, 220, 0.4),\n    rgba(207, 216, 220, 0.2)\n  );\n  border-radius: ", ";\n"])), function (props) {
    return props.width;
}, function (props) {
    return props.height;
}, function (props) {
    return props.rounded ? '50%' : 'none';
});
var generate = exports.generate = function generate(_a, imageSize, transformOptions) {
    var id = _a.id,
        _b = _a.type,
        type = _b === void 0 ? 'image' : _b;
    if (transformOptions === void 0) {
        transformOptions = {};
    }
    var dimensions = imageSize && "w_" + imageSize.width + ",h_" + imageSize.height;
    return window.env && window.env.CLOUDINARY_DOWNLOAD_URL && window.env.CLOUDINARY_DOWNLOAD_URL + "/" + type + "/" + (0, _cloudinary.getCloudinaryTransforms)({
        dimensions: dimensions,
        useSourceFormat: transformOptions.useSourceFormat,
        color: transformOptions.color,
        rounded: transformOptions.rounded,
        quality: transformOptions.quality
    }) + "/" + id || '';
};
var MIN_WIDTHS = exports.MIN_WIDTHS = {
    hd: '(min-width: 90rem)',
    desktop: '(min-width: 64rem)',
    tablet: '(min-width: 40rem)'
};
var CloudinaryImage = function CloudinaryImage(_a) {
    var source = _a.source,
        alt = _a.alt,
        sizes = _a.sizes,
        rounded = _a.rounded,
        className = _a.className,
        useSourceFormat = _a.useSourceFormat,
        color = _a.color,
        quality = _a.quality,
        onError = _a.onError;
    if (!source) {
        if (sizes && sizes.hd && window.matchMedia(MIN_WIDTHS.hd).matches) {
            return React.createElement(Placeholder, { width: sizes.hd.width, height: sizes.hd.height, rounded: rounded });
        }
        if (sizes && sizes.desktop && window.matchMedia(MIN_WIDTHS.desktop).matches) {
            return React.createElement(Placeholder, { width: sizes.desktop.width, height: sizes.desktop.height, rounded: rounded });
        }
        if (sizes && sizes.tablet && window.matchMedia(MIN_WIDTHS.tablet).matches) {
            return React.createElement(Placeholder, { width: sizes.tablet.width, height: sizes.tablet.height, rounded: rounded });
        }
        if (sizes && sizes.mobile) {
            return React.createElement(Placeholder, { width: sizes.mobile.width, height: sizes.mobile.height, rounded: rounded });
        }
        return React.createElement(Placeholder, { width: 100, height: 100, rounded: rounded });
    }
    return React.createElement("picture", { className: className }, sizes && sizes.hd && React.createElement("source", { srcSet: generate(source, sizes.hd, {
            rounded: rounded,
            useSourceFormat: useSourceFormat,
            color: color,
            quality: quality
        }), media: MIN_WIDTHS.hd }), sizes && sizes.desktop && React.createElement("source", { srcSet: generate(source, sizes.desktop, {
            rounded: rounded,
            useSourceFormat: useSourceFormat,
            color: color,
            quality: quality
        }), media: MIN_WIDTHS.desktop }), sizes && sizes.tablet && React.createElement("source", { srcSet: generate(source, sizes.tablet, {
            rounded: rounded,
            useSourceFormat: useSourceFormat,
            color: color,
            quality: quality
        }), media: MIN_WIDTHS.tablet }), sizes && sizes.mobile && React.createElement("source", { srcSet: generate(source, sizes.mobile, {
            rounded: rounded,
            useSourceFormat: useSourceFormat,
            color: color,
            quality: quality
        }) }), React.createElement("img", { src: generate(source, sizes && sizes.desktop || undefined, {
            rounded: rounded,
            useSourceFormat: useSourceFormat,
            color: color,
            quality: quality
        }), onError: onError, alt: alt }));
};
exports.default = CloudinaryImage;

var templateObject_1;
//# sourceMappingURL=CloudinaryImage.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/CloudinaryImage/CloudinaryImage.js
// module id = 126
// module chunks = 0